import LichThiDauFull from "@/components/LichThiDauFull";

export default function BangKeoKetQuaFull() {
  return <LichThiDauFull type="ketqua" />;
}
